// The IAM role claim is not a stable shape: an identity provider emits a plain
// string when the user has exactly one role and an array when they have
// several. Anything reading the claim must normalise before matching, or a
// user with ['BackOffice', 'UserManager'] fails a check that a user with only
// 'BackOffice' passes.
export const ROLE_CLAIM =
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'

// Flattens the claim (string | string[] | nested) to a deduplicated list of
// role names. Deliberately does not split on any separator: every known role
// name arrives as its own claim value, and inventing names out of one value
// would widen an authorization gate.
export const normalizeRoles = (claim: unknown): string[] => {
  if (claim === null || claim === undefined) {
    return []
  }

  const flat = (Array.isArray(claim) ? claim.flat(Infinity) : [claim]).filter(
    (value): value is string => typeof value === 'string' && value.length > 0
  )

  return Array.from(new Set(flat))
}

// Exact match, as IAM emits role names with stable casing. This is only about
// the claim's *shape*, so it must not loosen which names count as a match.
export const hasRole = (roles: unknown, role: string): boolean =>
  normalizeRoles(roles).includes(role)
